import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { connect } from 'react-redux'
import { useNavigate } from 'react-router-dom';
import { getLink } from "../../dataProvider/links.js";
import UploadBlock from "../upload/UploadBlock";

import blueLeftBackground from '../../img/v2/home/blueLeftBackground.png'
import blueRightBackground from '../../img/v2/home/blueRightBackground.png'

import "../../scss/v2/user/convert.scss"

function Convert(props) {

    const { t, i18n } = useTranslation();
    let navigate = useNavigate();

    useEffect(() => {
        if (!props.user || !props.user.connected) return navigate(getLink('login', i18n.language));
    }, [props, i18n, navigate])


    return (
        <div className="user-convert" >
            <div className="container" >
                <div className="text-center">
                    <h1 className="user-convert-title">{t("userConvert.title")}</h1>
                    <p className="user-convert-subtitle">{t("userConvert.subtitle")}</p>
                </div>
                <div className="square-background">
                    <img className="img img-fluid left-square-background" src={blueLeftBackground} alt={blueLeftBackground} />
                    <div className="square-bakground-content">
                        <div className="row">
                            <div className="col-12 col-lg-8 offset-lg-2">
                                <UploadBlock />
                            </div>
                        </div>
                    </div>
                    <img className="img img-fluid right-square-background" src={blueRightBackground} alt={blueRightBackground} />
                </div>
            </div>
        </div>
    )
}

const mapStateToProps = state => ({ user: state.user.user })

const mapDispatchToProps = dispatch => ({ dispatch })

export default connect(mapStateToProps, mapDispatchToProps)(Convert);